module.exports = __webpack_public_path__ + "static/source-sans-pro-v11-latin-600-b3866d3fbe239e8754f4db4795ce2817.woff2";